import React, { Component } from 'react';

import { Row, Col, Button, Popover, Card,Modal} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import {
    InstagramOutlined,
    MailOutlined,
    LinkedinOutlined,
} from '@ant-design/icons';
import LazyLoad from 'react-lazyload';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css"

function info(cv) {
    Modal.info({
        
        content: (
            <div>
                <p>
                    {cv}
                </p>
            </div>
        ),
        onOk() { },
        okText:"بستن",
    });
}

const humanResourceCard ={
    borderRadius:"10px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    margin:"10px"
}
const HumanResourceCard = props => {
    return props.size === "laptopdesktop" ? (
        <div>
            <Card style={humanResourceCard}>
                <Center>
                
                    <img
                        className="humanResourcePersonPic"
                        src={props.img}
                    />
                </Center>
                <Margin top={2}></Margin>
                <Center>
                    <Row style={{ direction: "rtl", textAlign: "right" }}>
                        <div className="personCardBorder" style={{ direction: "rtl", textAlign: "right", marginRight: "6.5px" }}></div>
                        <div style={{ marginTop: "-2.5px" }}>
                            <strong style={{ fontFamily: "IranSans", fontSize: ".9em", color: "#174561", paddingRight: "5px" }}>{props.name}</strong>
                            <p style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#8d8d8d", paddingRight: "5px" }}>{props.job}</p>
                        </div>
                    </Row>
                </Center>
                {/* <Center>
                    <p style={{ fontFamily: "IranSans", fontSize: ".85em", color: "#8d8d8d", paddingRight: "5px" }}>شماره تماس: {props.phone}</p>
                </Center>
                <Center>
                    <div style={{ direction: "rtl", textAlign: "right" }}>
                        <a onClick={() => info(props.cv)} style={{ fontSize: ".85em", fontFamily: "IRANSans", paddingRight: "20px", paddingLeft: "20px", paddingTop: "1.5px", paddingBottom: "1.5px", backgroundColor: "#186491", color: "#fff", borderRadius: "100px"}}>رزومه</a>
                    </div>
                </Center> */}
                {/* <Margin top={2} />
                <Row>
                    <Col span={18}>
                        <a><LinkedinOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#2867B2" }} /></a>
                        <Popover content={props.mail} placement="bottom">
                            <a><MailOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#4a00a0" }} /></a>
                        </Popover>
                        <a><InstagramOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#E1306C" }} /></a>
                    </Col>
                    <Col span={6} style={{ direction: "rtl", textAlign: "right" }}>

                    </Col>
                </Row> */}
            </Card>           
        </div>
     ) : props.size === "tablet" ? (
        <div>
        <Card style={humanResourceCard}>
            <Center>
                <img
                    className="tabletImg"
                    src={props.img}
                />
            </Center>
            <Margin top={2}></Margin>
            <Center>
                <Row style={{ direction: "rtl", textAlign: "right" }}>
                    <div className="personCardBorder" style={{ direction: "rtl", textAlign: "right", marginRight: "6.5px" }}></div>
                    <div style={{ marginTop: "-2.5px" }}>
                        <strong style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#174561", paddingRight: "5px" }}>{props.name}</strong>
                        <p style={{ fontFamily: "IranSans", fontSize: ".75em", color: "#8d8d8d", paddingRight: "5px" }}>{props.job}</p>
                    </div>
                </Row>
            </Center>
            {/* <Center>
                <p style={{ fontFamily: "IranSans", fontSize: ".75em", color: "#8d8d8d", paddingRight: "5px" }}>شماره تماس: {props.phone}</p>
            </Center>
            <Center>
                <div style={{ direction: "rtl", textAlign: "right" }}>
                    <a href="#" class="introBtn introBtn-white introBtn-animated" style={{ fontSize: ".75em", fontFamily: "IRANSans", paddingRight: "20px", paddingLeft: "20px", paddingTop: "1.5px", paddingBottom: "1.5px" }}>رزومه</a>
                </div>
            </Center> */}
            {/* <Margin top={2} />
            <Row>
                <Col span={18}>
                    <a><LinkedinOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#2867B2" }} /></a>
                    <Popover content={props.mail} placement="bottom">
                        <a><MailOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#4a00a0" }} /></a>
                    </Popover>
                    <a><InstagramOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#E1306C" }} /></a>
                </Col>
                <Col span={6} style={{ direction: "rtl", textAlign: "right" }}>

                </Col>
            </Row> */}
        </Card>           
    </div>
     ) : (
            <div>
            <Card style={humanResourceCard}>
                <Center>
                <img
                    className="humanResourcePersonPic"
                    src={props.img}
                />
                </Center>
                <Margin top={2}></Margin>
                <Center>
                <Row style={{ direction: "rtl", textAlign: "right" }}>
                    <div className="personCardBorder" style={{ direction: "rtl", textAlign: "right", marginRight: "6.5px" }}></div>
                    <div style={{ marginTop: "-2.5px" }}>
                        <strong style={{ fontFamily: "IranSans", fontSize: ".85em", color: "#174561", paddingRight: "5px" }}>{props.name}</strong>
                        <p style={{ fontFamily: "IranSans", fontSize: ".75em", color: "#8d8d8d", paddingRight: "5px" }}>{props.job}</p>
                    </div>
                </Row>
                </Center>
                {/* <Center>
                <p style={{ fontFamily: "IranSans", fontSize: ".75em", color: "#8d8d8d", paddingRight: "5px" }}>شماره تماس: {props.phone}</p>
                </Center>
                <Center>
                <div style={{ direction: "rtl", textAlign: "right" }}>
                    <a href="#" class="introBtn introBtn-white introBtn-animated" style={{ fontSize: ".7em", fontFamily: "IRANSans", paddingRight: "20px", paddingLeft: "20px", paddingTop: "1.5px", paddingBottom: "1.5px" }}>رزومه</a>
                </div>
                </Center> */}
                {/* <Margin top={2} />
                <Row>
                <Col span={18}>
                    <a><LinkedinOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#2867B2" }} /></a>
                    <Popover content={props.mail} placement="bottom">
                        <a><MailOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#4a00a0" }} /></a>
                    </Popover>
                    <a><InstagramOutlined style={{ fontSize: "1.3em", margin: "5px", color: "#E1306C" }} /></a>
                </Col>
                <Col span={6} style={{ direction: "rtl", textAlign: "right" }}>

                </Col>
                </Row> */}
            </Card>
            </div>
          );
};

export default HumanResourceCard;
